import { computed } from 'vue';
import store from '@/store';

export default class ErrorMessageCode {
	public errorMessage = computed((): string => {
		return store.getters.errorMessage();
	});
}
